import { useIntl } from 'react-intl';

import { IntlMsgShape } from 'helpers/consts';

import { FilterType } from 'store/modules/algolia_filters';

import threeSixtyaudios from 'assets/images/explore/discover/360audios.webp';
import guidedMasturbation from 'assets/images/explore/discover/guided-masturbation.webp';
import kinks from 'assets/images/explore/discover/kinks.webp';
import lgtbia from 'assets/images/explore/discover/lgbtqia.webp';
import scenarios from 'assets/images/explore/discover/scenarios.webp';
import selfLove from 'assets/images/explore/discover/self-love.webp';
import sounds from 'assets/images/explore/discover/sounds.webp';
import voices from 'assets/images/explore/discover/voices.webp';
import { ENGLISH_UK, ENGLISH_US, FRENCH_FRANCE } from 'constants/locales';
import { ContentType } from 'types/contentType';

export interface ExploreByOptionInterface {
  text: IntlMsgShape;
  link: string;
  image: string;
}

const createExploreByOption = (
  text: string,
  link: string,
  image: string,
): ExploreByOptionInterface => ({
  text: {
    id: text,
  },
  link,
  image,
});

const options: Array<ExploreByOptionInterface> = [
  createExploreByOption('components.exploreBy.kinks', '/explore/kinks', kinks),
  createExploreByOption(
    'components.exploreBy.scenarios',
    '/explore/scenarios',
    scenarios,
  ),
  createExploreByOption(
    'components.exploreBy.360audios',
    '/explore/360-audios',
    threeSixtyaudios,
  ),
  createExploreByOption(
    'components.exploreBy.voices',
    '/explore/voices',
    voices,
  ),
  createExploreByOption(
    'components.exploreBy.sounds',
    '/explore/sounds',
    sounds,
  ),
  createExploreByOption(
    'components.exploreBy.lgbtqia',
    '/explore/lgbtqia',
    lgtbia,
  ),
  createExploreByOption(
    'components.exploreBy.guidedSessions',
    '/explore/guided-sessions',
    guidedMasturbation,
  ),
  createExploreByOption(
    'components.exploreBy.selfLove',
    '/explore/self-love',
    selfLove,
  ),
];

const OptionsDE: Array<ExploreByOptionInterface> = options;
const OptionsFR: Array<ExploreByOptionInterface> = options;
const OptionsEN: Array<ExploreByOptionInterface> = options;

export const getExploreByOptions = (
  locale: string,
): Array<ExploreByOptionInterface> => {
  switch (locale) {
    case FRENCH_FRANCE:
      return OptionsFR;
    case ENGLISH_US:
    case ENGLISH_UK:
      return OptionsEN;
    default:
      return OptionsDE;
  }
};

export const useContentTypeStaticFilters = () => {
  const { formatMessage } = useIntl();

  return [
    {
      text: formatMessage({
        id: 'components.NewExplorePage.contentType.stories',
      }),
      filter: {
        type: FilterType.ContentType,
        value: ContentType.Story,
      },
    },
    {
      text: formatMessage({
        id: 'components.NewExplorePage.contentType.sounds',
      }),
      filter: {
        type: FilterType.ContentType,
        value: ContentType.Sounds,
      },
    },
    {
      text: formatMessage({
        id: 'components.NewExplorePage.contentType.soul',
      }),
      filter: {
        type: FilterType.ContentType,
        value: ContentType.Soul,
      },
    },
  ];
};
